// Friendly display names for clip style ids. Falls back to the raw id for any
// style not listed here (custom/registry-defined styles).

const STYLE_LABELS: Record<string, string> = {
  reel: 'Reel',
  quote: 'Quote',
  genericCarousel: 'Carousel',
  standard: 'Standard',
  medieval: 'Medieval',
  technologyCarousel: 'Technology Carousel',
};

export const clipStyleLabel = (styleId: string | undefined): string => {
  const id = (styleId || '').trim();
  if (!id) return '';
  return STYLE_LABELS[id] ?? id;
};
